import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingContactsContainerLoadable } from 'shared/components/contacts_aside';
import { NewbuildingOnlineStatusContainer } from 'shared/containers/NewbuildingOnlineStatusContainer';
import { isNewbuildingFromDeveloperSelector } from 'shared/selectors';
import { selectNewbuildingBrokerOfferBookingEnabled } from 'shared/selectors/featureToggle';
import { isPrintVersionPhoneVisibilitySelector } from 'shared/selectors/print';

import { NewbuildingMessageButtonContainer } from '../NewbuildingMessageButtonContainer';
import { PhonesContainer } from '../PhonesContainer';
import { usePhonesOpenedContext } from '../providers/PhonesOpened';

export const NewbuildingPageAsideContactsContainer = () => {
  const isNewbuildingFromDeveloper = useSelector(isNewbuildingFromDeveloperSelector);
  const isPrintVersion = useSelector(isPrintVersionPhoneVisibilitySelector);
  // TODO: В CD-235461 после запуска проекта бронирования удалить фича-флаг.
  const offerBookingEnabled = useSelector(selectNewbuildingBrokerOfferBookingEnabled);

  const { isPhonesOpened } = usePhonesOpenedContext();

  return (
    <>
      {!isPrintVersion && (
        <NewbuildingContactsContainerLoadable
          contactsButton={<PhonesContainer />}
          messageButton={
            offerBookingEnabled ? <NewbuildingMessageButtonContainer isPhonesOpened={isPhonesOpened} /> : null
          }
          messageButtonInSeparateRow={isPhonesOpened}
          callbackPlaceType="floating_block"
        />
      )}
      {!offerBookingEnabled && <NewbuildingMessageButtonContainer isPhonesOpened={isPhonesOpened} />}
      {isNewbuildingFromDeveloper && <NewbuildingOnlineStatusContainer />}
    </>
  );
};
